<button
    ctrlOverflowMenuOpener
    [aria-controls]="menuId"
    aria-label="Menu öffnen / schließen"
>
    <i ctrlIcon="kebab"> </i>
</button>

<ul
    ctrlOverflowMenu
    [id]="menuId"
    aria-label="menu"
    hidden="true"
>
    @for (menuItem of menuItems; track $index) {
        <li>
            @if (isActionItem(menuItem)) {
                <button
                    ctrlOverflowMenuItem
                    class="fw:semibold"
                    (click)="menuItem.action(context)"
                >
                    <i
                        class="fw:semibold"
                        [ctrlIcon]="menuItem.icon"
                    ></i
                    ><span>{{ menuItem.label }}</span>
                </button>
            }
            @if (isRouterLinkItem(menuItem)) {
                <a
                    ctrlOverflowMenuItem
                    class="fw:semibold bold"
                    [routerLink]="menuItem.route"
                >
                    <i
                        class="fw:semibold"
                        [ctrlIcon]="menuItem.icon"
                    ></i
                    ><span>{{ menuItem.label }}</span></a
                >
            }
        </li>
    }
</ul>
